import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';

export function Button({ variant = 'primary', className = '', ...props }: ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant }) {
  const variants: Record<Variant, string> = {
    primary: 'button button-primary',
    secondary: 'button button-secondary',
    ghost: 'button button-ghost',
    danger: 'button button-danger',
  };
  return <button className={`${variants[variant]} ${className}`} {...props} />;
}
